import {isUndefined} from './lodash';

type ParamValue = string | number | boolean | undefined;

export const setSearchParams = (paramsObject: Record<string, ParamValue>, search: string = '') => {
    const params = new URLSearchParams(search);

    Object.entries(paramsObject).forEach(([key, value]) => {
        const parameterValue = !isUndefined(value) ? String(value) : '';
        params.set(key, parameterValue);
    });

    return params.toString();
};

export const removeSearchParams = (search: string, paramsToDelete: string[]) => {
    const params = new URLSearchParams(search);
    paramsToDelete.forEach((key) => {
        params.delete(key);
    });
    return params.toString();
};

export const getSearchParam = (search: string, key: string) => {
    const params = new URLSearchParams(search);
    const value = params.get(key);

    if (value === null) return null;

    return value;
};
